export const EPG_SIMPLY_SOURCE = "epg-simply";
export const MAX_EPG_CHANNEL_ID_LENGTH = 255;
export function epgMappingOf(alternativeIds) {
    const hit = (alternativeIds !== null && alternativeIds !== void 0 ? alternativeIds : []).find((alt) => (alt === null || alt === void 0 ? void 0 : alt.source) === EPG_SIMPLY_SOURCE &&
        typeof alt.alternativeId === "string" &&
        alt.alternativeId.trim() !== "");
    return hit ? hit.alternativeId : null;
}
export function epgMappingStatus(asset) {
    if (asset.alternativeIds === undefined)
        return "unknown";
    return epgMappingOf(asset.alternativeIds) ? "mapped" : "unmapped";
}
export function readEpgChannelId(raw) {
    const text = typeof raw === "string" ? raw.trim() : "";
    if (text === "")
        return { issue: { code: "blank", value: "" } };
    if (/\s/.test(text)) {
        return { issue: { code: "has_whitespace", value: text } };
    }
    if (/[\u0000-\u001f\u007f]/.test(text)) {
        return { issue: { code: "control_characters", value: text } };
    }
    if (text.length > MAX_EPG_CHANNEL_ID_LENGTH) {
        return { issue: { code: "too_long", value: text } };
    }
    return { value: text };
}
export function planEpgMappingWrite(current, raw) {
    const read = readEpgChannelId(raw);
    if ("issue" in read)
        return { kind: "invalid", issue: read.issue };
    if (current === null)
        return { kind: "create", alternativeId: read.value };
    if (current === read.value) {
        return { kind: "unchanged", alternativeId: read.value };
    }
    return { kind: "immutable", current, attempted: read.value };
}
